import Image from 'next/image';
import PropTypes from 'prop-types';
import React from 'react';
import SelectTabletsStyled from './SelectTabletsStyled';

const SelectTablets = ({
  label,
  firstVal,
  secondVal,
  thirdVal,
  error,
  onClick,
  activeVal,
  name,
  firstLabelImage,
  secondLabelImage,
  firstLabelImageBlue,
  secondLabelImageBlue,
  showFailureModal,
  isFromVital,
  isExistingUser
}) => (
  <SelectTabletsStyled showFailureModal={showFailureModal} isExistingUser={isExistingUser}>
    <div className="label">{label}</div>
    {!isFromVital && <input name={name} className="hidden" disabled />}{' '}
    <div className={`tabletContainer ${error ? 'is-invalid' : ''}`}>
      <div
        onClick={() => onClick(firstVal.toLowerCase())}
        className={activeVal?.toLowerCase() === firstVal.toLowerCase() ? 'outer active' : 'outer'}
      >
        {firstLabelImage ? (
          <div className="labelWithImage">
            <Image
              src={activeVal?.toLowerCase() === firstVal.toLowerCase() ? firstLabelImageBlue : firstLabelImage}
              alt={firstVal}
            />
            <div>{firstVal}</div>
          </div>
        ) : (
          firstVal
        )}
      </div>
      {secondVal ? (
        <div
          onClick={() => onClick(secondVal.toLowerCase())}
          className={activeVal?.toLowerCase() === secondVal.toLowerCase() ? 'outer active' : 'outer'}
        >
          {secondLabelImage ? (
            <div className="labelWithImage">
              <Image
                src={activeVal?.toLowerCase() === secondVal.toLowerCase() ? secondLabelImageBlue : secondLabelImage}
                alt={secondVal}
              />
              <div>{secondVal}</div>
            </div>
          ) : (
            secondVal
          )}
        </div>
      ) : null}
      {thirdVal ? (
        <div
          onClick={() => onClick(thirdVal.toLowerCase())}
          className={activeVal?.toLowerCase() === thirdVal.toLowerCase() ? 'outer active' : 'outer'}
        >
          {secondLabelImage ? (
            <div className="labelWithImage">
              <Image
                src={activeVal?.toLowerCase() === thirdVal.toLowerCase() ? secondLabelImageBlue : secondLabelImage}
                alt={thirdVal}
              />
              <div>{thirdVal}</div>
            </div>
          ) : (
            thirdVal
          )}
        </div>
      ) : null}
    </div>
    {error ? <div className="error">{error}</div> : null}
  </SelectTabletsStyled>
);

SelectTablets.propTypes = {
  label: PropTypes.string,
  firstVal: PropTypes.string,
  secondVal: PropTypes.string,
  thirdVal: PropTypes.string,
  error: PropTypes.string,
  onClick: PropTypes.func,
  activeVal: PropTypes.string,
  name: PropTypes.string,
  firstLabelImage: PropTypes.string,
  secondLabelImage: PropTypes.string,
  firstLabelImageBlue: PropTypes.string,
  secondLabelImageBlue: PropTypes.string,
  showFailureModal: PropTypes.bool,
  isFromVital: PropTypes.bool,
};

SelectTablets.defaultProps = {
  label: '',
  firstVal: '',
  secondVal: '',
  thirdVal: '',
  error: '',
  onClick: () => {},
  activeVal: '',
  name: '',
  firstLabelImage: '',
  secondLabelImage: '',
  firstLabelImageBlue: '',
  secondLabelImageBlue: '',
  showFailureModal: false,
  isFromVital: false,
};

export default SelectTablets;
